import { routeConstant } from "shared/routes/routeConstant";
import {
  clientSideBarConstants,
  mobileNavItemsClient,
} from "shared/utils/constants";
import DashboardWrapper from "../../dashboardCommon/dashboardWrapper";

interface Props {
  children: any;
}

function ClientWrapper({ children }: Props) {
  const mainPages = [
    routeConstant.client.projects.path,
    routeConstant.client.archivedProjects.path,
    routeConstant.client.notifications.path,
    routeConstant.client.accountSetting.path,
    routeConstant.client.contact.path,
    routeConstant.client.documents.path,
  ];

  return (
    <DashboardWrapper
      sidebarArr={clientSideBarConstants}
      mobileNavItems={mobileNavItemsClient}
      mainPages={mainPages}
      userType="client"
      showMobileNavConditionally={true}
    >
      {children}
    </DashboardWrapper>
  );
}

export default ClientWrapper;
